module.exports = __webpack_public_path__ + "media/images/JemTheMovie/web_facebook_icon_x100-0e16c5f42f50e4112864c4f6566e88f4.png";